export const APP_URL = 'https://app.minnimap.com';
export const CONTACT_EMAIL = 'contact@stevenroberts.info';
